/**
 * ModeBadge, surfaces D-088 connector mode honestly to admins.
 *
 *   "Hosted by Olytic", connector_mode='custom', Olytic owns the microservice
 *                        and the full SLA. Tier 4 governance available.
 *
 *   "{Vendor} MCP"    , connector_mode='proxy', Olytic gateway forwards
 *                        to the vendor's upstream MCP server. Tiers 0-3
 *                        only; SLA depends on vendor uptime.
 *
 * The label appears in the catalog detail page, the admin install modal,
 * and the AdminConnectors instance list so admins know what they're getting
 * before they install.
 */

import type { ConnectorMode } from '../lib/api.ts';

interface ModeBadgeProps {
  mode: ConnectorMode;
  /** Vendor display name, used for the "{Vendor} MCP" rendering of proxy mode. */
  vendorName: string;
}

export function ModeBadge({ mode, vendorName }: ModeBadgeProps) {
  if (mode === 'custom') {
    return (
      <span className="pill pill-info" title="Olytic-owned Cloud Run microservice. Full SLA + Tier 4 governance.">
        Hosted by Olytic
      </span>
    );
  }
  return (
    <span
      className="pill pill-neutral"
      title="Olytic gateway forwards to the vendor's upstream MCP server. SLA depends on vendor uptime."
    >
      {vendorName} MCP
    </span>
  );
}

/**
 * SlaDisclosure, small italic footnote rendered under tile or detail header
 * for proxy-mode connectors so customers know their tool calls depend on
 * upstream MCP uptime.
 */
export function SlaDisclosure({ text }: { text: string | null }) {
  if (text === null) return null;
  return (
    <p
      style={{
        margin: '6px 0 0',
        fontSize: '11px',
        color: 'var(--fg-muted)',
        fontStyle: 'italic',
      }}
    >
      {text}
    </p>
  );
}
